<template>
  <div>
    <el-table
      border
      :data="listData"
      size="medium"
      highlight-current-row
      header-row-class-name="table-header"
    >
      <el-table-column
        label="序号"
        prop="index"
        align="center"
        type="index"
        width="60"
      />
      <el-table-column
        label="项目名称"
        prop="projectName"
        align="center"
        min-width="130"
        show-overflow-tooltip
      >
        <template slot-scope="{ row }">
          <span>{{ row.projectName || ' - ' }}</span>
        </template>
      </el-table-column>
      <el-table-column
        label="项目编号"
        prop="projectCode"
        align="center"
        min-width="100"
        show-overflow-tooltip
      >
        <template slot-scope="{ row }">
          <span>{{ row.projectCode || ' - ' }}</span>
        </template>
      </el-table-column>
      <el-table-column
        label="项目类型"
        prop="projectType"
        align="center"
        min-width="130"
      >
        <template slot-scope="{ row }">
          <span>
            {{ projectTypeDict.translate(row.projectType).label || ' - ' }}
          </span>
        </template>
      </el-table-column>
      <el-table-column
        label="项目概算"
        prop="budget"
        align="center"
        min-width="130"
      >
        <template slot-scope="{ row }">
          <span> {{ row.budget | projectEstimateFilter }}(元) </span>
        </template>
      </el-table-column>
      <el-table-column
        label="委托状态"
        prop="acceptStatus"
        align="center"
        min-width="100"
      >
        <template slot-scope="{ row }">
          <el-tag
            v-if="statusDict.translate(row.acceptStatus)"
            size="small"
            :type="statusDict.translate(row.acceptStatus).type"
          >
            {{ statusDict.translate(row.acceptStatus).label }}
          </el-tag>
          <span v-else> - </span>
        </template>
      </el-table-column>
      <el-table-column
        label="委托时间"
        prop="entrustTime"
        align="center"
        min-width="180"
      >
        <template slot-scope="{ row }">
          <div>{{ row.entrustTime || ' - ' }}</div>
        </template>
      </el-table-column>
      <el-table-column label="操作" align="center" width="200" fixed="right">
        <slot></slot>
      </el-table-column>
    </el-table>

    <pagination
      v-show="total > 0"
      :total="total"
      :page.sync="page"
      :limit.sync="size"
    />
  </div>
</template>

<script>
import Pagination from '@/components/common/Pagination'
import { projectTypeDict } from '@/dictionary/project/common'

export default {
  components: {
    Pagination
  },

  props: {
    listData: {
      type: Array,
      default: () => []
    },

    total: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      projectTypeDict
    }
  }
}
</script>
